export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: any; output: any; }
  BigInteger: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
};

export type AcceptedTermsAndConditionsDto = {
  /** ISO-8601 */
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  postalCode?: Maybe<Scalars['String']['output']>;
  postalPlace?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

export enum ClassificationType {
  AGRICULTURE = 'AGRICULTURE',
  BUSINESS = 'BUSINESS',
  HOUSEHOLD = 'HOUSEHOLD',
  RECREATION = 'RECREATION',
  UNKNOWN = 'UNKNOWN'
}

export type Content = {
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ContentImage>;
  link?: Maybe<ContentLink>;
  pageContent?: Maybe<ContentEditorData>;
  pageImage?: Maybe<ContentImage>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  publishDate?: Maybe<Scalars['DateTime']['output']>;
  published: Scalars['Boolean']['output'];
  segmentIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  segmentNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  uniqueImpressions?: Maybe<Scalars['BigInteger']['output']>;
};

export type ContentEditorData = {
  html?: Maybe<Scalars['String']['output']>;
  json?: Maybe<Scalars['String']['output']>;
};

export type ContentEditorDataInput = {
  html?: InputMaybe<Scalars['String']['input']>;
  json?: InputMaybe<Scalars['String']['input']>;
};

export type ContentImage = {
  provider?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ContentImageInput = {
  provider?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ContentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ContentImageInput>;
  link?: InputMaybe<ContentLinkInput>;
  pageContent?: InputMaybe<ContentEditorDataInput>;
  pageImage?: InputMaybe<ContentImageInput>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  published: Scalars['Boolean']['input'];
  segmentIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  segmentNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentLink = {
  type?: Maybe<ContentLinkType>;
  url?: Maybe<Scalars['String']['output']>;
  view?: Maybe<Scalars['String']['output']>;
  viewType?: Maybe<Scalars['String']['output']>;
};

export type ContentLinkInput = {
  type?: InputMaybe<ContentLinkType>;
  url?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<Scalars['String']['input']>;
};

export enum ContentLinkType {
  APP = 'APP',
  APP_CONTENT_PAGE = 'APP_CONTENT_PAGE',
  NO_LINK = 'NO_LINK',
  WEB = 'WEB'
}

export type Contract = {
  _id?: Maybe<Scalars['String']['output']>;
  accountGuid?: Maybe<Scalars['String']['output']>;
  accountingPointGuid?: Maybe<Scalars['String']['output']>;
  customerGuid?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  meterNumber?: Maybe<Scalars['String']['output']>;
  meterPointId?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum ContractStatus {
  ACTIVE = 'ACTIVE',
  CEASED = 'CEASED',
  IN_TAKEOVER = 'IN_TAKEOVER',
  PROCESSING = 'PROCESSING',
  TO_BE_CEASED = 'TO_BE_CEASED',
  UNKNOWN = 'UNKNOWN',
  WAITING_TRANSFER = 'WAITING_TRANSFER'
}

export type CountUsersWithSegmentsResponse = {
  inSegments: Scalars['BigInteger']['output'];
  total: Scalars['BigInteger']['output'];
};

export type CursorPaginationResponse_Content = {
  items?: Maybe<Array<Maybe<Content>>>;
  total?: Maybe<Scalars['BigInteger']['output']>;
};

export type CursorPaginationResponse_HelpPage = {
  items?: Maybe<Array<Maybe<HelpPage>>>;
  total?: Maybe<Scalars['BigInteger']['output']>;
};

export type CursorPaginationResponse_ServiceMessage = {
  items?: Maybe<Array<Maybe<ServiceMessage>>>;
  total?: Maybe<Scalars['BigInteger']['output']>;
};

export type CursorPaginationResponse_User = {
  items?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['BigInteger']['output']>;
};

export type DefaultAddress = {
  buildingNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  postalName?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
};

export type Device = {
  appVersion?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  /** ISO-8601 */
  lastSeen?: Maybe<Scalars['DateTime']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notificationsDisabled?: Maybe<Scalars['Boolean']['output']>;
  operatingSystem?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  pushNotificationToken?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ElectricityContract = {
  contractId?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** ISO-8601 */
  dateTo?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  managedPrice?: Maybe<Scalars['Boolean']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Product>>>;
  status?: Maybe<ContractStatus>;
};

export enum ElectricityPriceZone {
  NO1 = 'NO1',
  NO2 = 'NO2',
  NO3 = 'NO3',
  NO4 = 'NO4',
  NO5 = 'NO5'
}

export type FeatureFlag = {
  description?: Maybe<Scalars['String']['output']>;
  disabledMessage?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** ISO-8601 */
  from?: Maybe<Scalars['Date']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  propertiesJson?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  to?: Maybe<Scalars['Date']['output']>;
  usersCount?: Maybe<Scalars['BigInteger']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type FeatureFlagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabledMessage?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** ISO-8601 */
  from?: InputMaybe<Scalars['Date']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  propertiesJson?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  to?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type Fjutt = {
  anleggsId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
};

export type Group = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  featureFlagKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  featureFlags?: Maybe<Array<Maybe<FeatureFlag>>>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  users?: Maybe<CursorPaginationResponse_User>;
  usersCanOptIn?: Maybe<Scalars['Boolean']['output']>;
  usersCount?: Maybe<Scalars['BigInteger']['output']>;
};


export type GroupUsersArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  featureFlagKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  usersCanOptIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HelpPage = {
  content?: Maybe<ContentEditorData>;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ContentImage>;
  locations?: Maybe<Array<Maybe<HelpPageLocation>>>;
  order: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  segmentIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  segmentNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HelpPageInput = {
  content?: InputMaybe<ContentEditorDataInput>;
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ContentImageInput>;
  locations?: InputMaybe<Array<InputMaybe<HelpPageLocation>>>;
  order: Scalars['Int']['input'];
  published: Scalars['Boolean']['input'];
  segmentIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  segmentNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum HelpPageLocation {
  FORBRUK = 'FORBRUK',
  HJEM = 'HJEM',
  KAPASITETSTRINN = 'KAPASITETSTRINN',
  KOSTNAD = 'KOSTNAD',
  MEG = 'MEG',
  MEG_BOLIGER_OG_AVTALER = 'MEG_BOLIGER_OG_AVTALER',
  MEG_FAKTURA = 'MEG_FAKTURA',
  MEG_FAKTURAOVERSIKT = 'MEG_FAKTURAOVERSIKT',
  MEG_TILGANGER = 'MEG_TILGANGER',
  MEG_VERVING = 'MEG_VERVING',
  SPOTPRIS = 'SPOTPRIS',
  TJENESTER = 'TJENESTER'
}

export type InfoText = {
  active: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  content?: Maybe<ContentEditorData>;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type InfoTextInput = {
  active: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ContentEditorDataInput>;
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  lastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Intercom = {
  androidHash?: Maybe<Scalars['String']['output']>;
  iosHash?: Maybe<Scalars['String']['output']>;
};

export type LabelSegment = {
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  numberOfSegments: Scalars['Int']['output'];
  segmentIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  segmentNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LabelSegmentInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  segmentIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  segmentNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Meter = {
  address?: Maybe<Address>;
  alias?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<MeterClassification>;
  electricityContracts?: Maybe<Array<Maybe<ElectricityContract>>>;
  gridOwner?: Maybe<Scalars['String']['output']>;
  gridOwnerGLN?: Maybe<Scalars['String']['output']>;
  gridOwnerMGA?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  meterId?: Maybe<Scalars['String']['output']>;
  meteringPointId?: Maybe<Scalars['String']['output']>;
  meteringType?: Maybe<MeterMeteringType>;
  owner?: Maybe<MeterOwner>;
  priceZone?: Maybe<ElectricityPriceZone>;
  scaling?: Maybe<MeterScaling>;
};

export type MeterClassification = {
  classification?: Maybe<ClassificationType>;
  consumptionCode?: Maybe<Scalars['String']['output']>;
};

export enum MeterMeteringType {
  Combined = 'Combined',
  Consumption = 'Consumption',
  Exchange = 'Exchange',
  Production = 'Production',
  Unknown = 'Unknown'
}

export type MeterOwner = {
  nameOfOwner?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OwnerType>;
};

export type MeterScaling = {
  factor?: Maybe<Scalars['Float']['output']>;
  /** ISO-8601 */
  fromDate?: Maybe<Scalars['DateTime']['output']>;
  /** ISO-8601 */
  validated?: Maybe<Scalars['DateTime']['output']>;
};

export type MigrationProgress = {
  changed: Scalars['BigInteger']['output'];
  percent: Scalars['Int']['output'];
  processed: Scalars['BigInteger']['output'];
  total: Scalars['BigInteger']['output'];
};

/** Mutation root */
export type Mutation = {
  /** Add user to group */
  addUserToGroup?: Maybe<User>;
  createInfoText?: Maybe<InfoText>;
  deleteContent?: Maybe<Content>;
  /** Delete device */
  deleteDevice: Scalars['Boolean']['output'];
  deleteFeatureFlag?: Maybe<FeatureFlag>;
  deleteGroup?: Maybe<Group>;
  deleteHelpPage?: Maybe<HelpPage>;
  deleteInfoText?: Maybe<InfoText>;
  deleteServiceMessage?: Maybe<ServiceMessage>;
  /** Delete users */
  deleteUser: Scalars['Boolean']['output'];
  removeFjuttFromUser: Scalars['Boolean']['output'];
  /** Remove user to group */
  removeUserFromGroup?: Maybe<User>;
  runCompanyAccessJob: Scalars['Boolean']['output'];
  sendForbruksstoppNotification: Scalars['Boolean']['output'];
  sendSpotpriceNotification: Scalars['Boolean']['output'];
  sendSpotpriceNotifications: Scalars['Boolean']['output'];
  sendWeekreportNotification: Scalars['Boolean']['output'];
  syncUser?: Maybe<SyncUserResponse>;
  updateInfoText?: Maybe<InfoText>;
  upsertContent?: Maybe<Content>;
  upsertFeatureFlag?: Maybe<FeatureFlag>;
  upsertGroup?: Maybe<Group>;
  upsertHelpPage?: Maybe<HelpPage>;
  upsertLabelSegment?: Maybe<LabelSegment>;
  upsertServiceMessage?: Maybe<ServiceMessage>;
};


/** Mutation root */
export type MutationAddUserToGroupArgs = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationCreateInfoTextArgs = {
  infoText: InfoTextInput;
};


/** Mutation root */
export type MutationDeleteContentArgs = {
  contentId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationDeleteDeviceArgs = {
  deviceid: Scalars['String']['input'];
  userid: Scalars['String']['input'];
};


/** Mutation root */
export type MutationDeleteFeatureFlagArgs = {
  featureFlagId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationDeleteGroupArgs = {
  groupId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationDeleteHelpPageArgs = {
  helpPageId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationDeleteInfoTextArgs = {
  infoTextId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationDeleteServiceMessageArgs = {
  serviceMessageId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationDeleteUserArgs = {
  userid: Scalars['String']['input'];
};


/** Mutation root */
export type MutationRemoveFjuttFromUserArgs = {
  fjuttId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation root */
export type MutationRemoveUserFromGroupArgs = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationRunCompanyAccessJobArgs = {
  secret?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation root */
export type MutationSendForbruksstoppNotificationArgs = {
  measuringpointId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation root */
export type MutationSendSpotpriceNotificationArgs = {
  area?: InputMaybe<NordpoolArea>;
  operator?: InputMaybe<SpotpriceLevelOperator>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation root */
export type MutationSendWeekreportNotificationArgs = {
  measuringpointId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  week: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationSyncUserArgs = {
  userId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationUpdateInfoTextArgs = {
  infoText: InfoTextInput;
};


/** Mutation root */
export type MutationUpsertContentArgs = {
  content: ContentInput;
};


/** Mutation root */
export type MutationUpsertFeatureFlagArgs = {
  featureFlag: FeatureFlagInput;
};


/** Mutation root */
export type MutationUpsertGroupArgs = {
  group: GroupInput;
};


/** Mutation root */
export type MutationUpsertHelpPageArgs = {
  helpPage: HelpPageInput;
};


/** Mutation root */
export type MutationUpsertLabelSegmentArgs = {
  labelSegment: LabelSegmentInput;
};


/** Mutation root */
export type MutationUpsertServiceMessageArgs = {
  serviceMessage: ServiceMessageInput;
};

export enum NordpoolArea {
  NO1 = 'NO1',
  NO2 = 'NO2',
  NO3 = 'NO3',
  NO4 = 'NO4',
  NO5 = 'NO5'
}

export enum NotificationType {
  FORBRUKSTOPP = 'FORBRUKSTOPP',
  LINK = 'LINK',
  OTHER = 'OTHER',
  REALTIME_CONSUMPTION = 'REALTIME_CONSUMPTION',
  SHARING = 'SHARING',
  SPOTPRICE = 'SPOTPRICE',
  VERVING = 'VERVING',
  WEEKREPORT = 'WEEKREPORT'
}

export enum OwnerType {
  COMPANY = 'COMPANY',
  OWNER_PRIVATE = 'OWNER_PRIVATE',
  SHARED_COMPANY = 'SHARED_COMPANY',
  SHARED_PRIVATE = 'SHARED_PRIVATE',
  UNKNOWN = 'UNKNOWN'
}

export type Product = {
  code?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  from?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  /** ISO-8601 */
  to?: Maybe<Scalars['Date']['output']>;
};

/** Query root */
export type Query = {
  allInfoTexts?: Maybe<Array<Maybe<InfoText>>>;
  countUsersWithSegments?: Maybe<CountUsersWithSegmentsResponse>;
  featureFlag?: Maybe<FeatureFlag>;
  featureFlags?: Maybe<Array<Maybe<FeatureFlag>>>;
  featureFlagsByUserId?: Maybe<Array<Maybe<FeatureFlag>>>;
  /** Get grid owners */
  gridOwners?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  group?: Maybe<Group>;
  groups?: Maybe<Array<Maybe<Group>>>;
  groupsByUserId?: Maybe<Array<Maybe<Group>>>;
  labelSegments?: Maybe<Array<Maybe<LabelSegment>>>;
  paginateContent?: Maybe<CursorPaginationResponse_Content>;
  paginateHelpPages?: Maybe<CursorPaginationResponse_HelpPage>;
  paginateServiceMessages?: Maybe<CursorPaginationResponse_ServiceMessage>;
  /** Paginate users */
  paginatedUsers?: Maybe<CursorPaginationResponse_User>;
  segments?: Maybe<Array<Maybe<Segment>>>;
  singleContent?: Maybe<Content>;
  singleHelpPage?: Maybe<HelpPage>;
  singleInfoText?: Maybe<InfoText>;
  singleLabelSegment?: Maybe<LabelSegment>;
  singleServiceMessage?: Maybe<ServiceMessage>;
  subscriptionStatistics?: Maybe<Array<Maybe<SubscriptionStatistic>>>;
  /** Get user by id */
  user?: Maybe<User>;
  /** List all users */
  users?: Maybe<Array<Maybe<User>>>;
};


/** Query root */
export type QueryCountUsersWithSegmentsArgs = {
  segmentIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  segmentNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Query root */
export type QueryFeatureFlagArgs = {
  id: Scalars['String']['input'];
};


/** Query root */
export type QueryFeatureFlagsByUserIdArgs = {
  userId: Scalars['String']['input'];
};


/** Query root */
export type QueryGroupArgs = {
  groupId: Scalars['String']['input'];
};


/** Query root */
export type QueryGroupsByUserIdArgs = {
  userId: Scalars['String']['input'];
};


/** Query root */
export type QueryPaginateContentArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryPaginateHelpPagesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryPaginateServiceMessagesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryPaginatedUsersArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  deviceLastSeenAfter?: InputMaybe<Scalars['DateTime']['input']>;
  devicePlatform?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
  userFilter?: InputMaybe<UserFilter>;
};


/** Query root */
export type QuerySingleContentArgs = {
  contentId: Scalars['String']['input'];
};


/** Query root */
export type QuerySingleHelpPageArgs = {
  helpPageId: Scalars['String']['input'];
};


/** Query root */
export type QuerySingleInfoTextArgs = {
  infoTextId: Scalars['String']['input'];
};


/** Query root */
export type QuerySingleLabelSegmentArgs = {
  labelSegmentId: Scalars['String']['input'];
};


/** Query root */
export type QuerySingleServiceMessageArgs = {
  serviceMessageId: Scalars['String']['input'];
};


/** Query root */
export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


/** Query root */
export type QueryUsersArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type Segment = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ServiceMessage = {
  application?: Maybe<ServiceMessageApplication>;
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Array<Maybe<ServiceMessageLocation>>>;
  /** ISO-8601 */
  publishDate?: Maybe<Scalars['DateTime']['output']>;
  published: Scalars['Boolean']['output'];
  segmentIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  segmentNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  unPublishDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum ServiceMessageApplication {
  BEDRIFTSPORTALEN = 'BEDRIFTSPORTALEN',
  MITT_NTE = 'MITT_NTE',
  STROMBESTILLING = 'STROMBESTILLING'
}

export type ServiceMessageInput = {
  application?: InputMaybe<ServiceMessageApplication>;
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Array<InputMaybe<ServiceMessageLocation>>>;
  /** ISO-8601 */
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  published: Scalars['Boolean']['input'];
  segmentIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  segmentNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  unPublishDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ServiceMessageLocation {
  FJUTT = 'FJUTT',
  FORBRUK = 'FORBRUK',
  GLOBAL = 'GLOBAL',
  HJEM = 'HJEM',
  KAPASITETSTRINN = 'KAPASITETSTRINN',
  KOSTNAD = 'KOSTNAD',
  LOGIN = 'LOGIN',
  MEG = 'MEG',
  MEG_BOLIGER_OG_AVTALER = 'MEG_BOLIGER_OG_AVTALER',
  MEG_FAKTURA = 'MEG_FAKTURA',
  MEG_FAKTURAOVERSIKT = 'MEG_FAKTURAOVERSIKT',
  MEG_TILGANGER = 'MEG_TILGANGER',
  MEG_VERVING = 'MEG_VERVING',
  NYTT = 'NYTT',
  SPOTPRIS = 'SPOTPRIS',
  STROMBESTILLING_FRONTEND = 'STROMBESTILLING_FRONTEND',
  STROMTILBUD = 'STROMTILBUD',
  TJENESTER = 'TJENESTER',
  VARSLINGER = 'VARSLINGER'
}

export enum SpotpriceLevelOperator {
  OVER = 'OVER',
  UNDER = 'UNDER'
}

/** Subscription root */
export type Subscription = {
  migrate?: Maybe<MigrationProgress>;
};


/** Subscription root */
export type SubscriptionMigrateArgs = {
  dryRun: Scalars['Boolean']['input'];
  migration?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionStatistic = {
  totalCount: Scalars['BigInteger']['output'];
  type?: Maybe<NotificationType>;
  uniqueUsers: Scalars['BigInteger']['output'];
};

export type SyncUserResponse = {
  success: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type User = {
  acceptedTermsAndConditions?: Maybe<Array<Maybe<AcceptedTermsAndConditionsDto>>>;
  /** ISO-8601 */
  birthDate?: Maybe<Scalars['Date']['output']>;
  /** ISO-8601 */
  created?: Maybe<Scalars['DateTime']['output']>;
  defaultAddress?: Maybe<DefaultAddress>;
  devices?: Maybe<Array<Maybe<Device>>>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fjutter?: Maybe<Array<Maybe<Fjutt>>>;
  groupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groups?: Maybe<Array<Maybe<Group>>>;
  hasActiveContract: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  idProviderSubject?: Maybe<Scalars['String']['output']>;
  intercom?: Maybe<Intercom>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  meters?: Maybe<Array<Maybe<Meter>>>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  ownedContracts?: Maybe<Array<Maybe<Contract>>>;
  segments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sharedContracts?: Maybe<Array<Maybe<Contract>>>;
  trackingId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserFilter = {
  fjutt?: InputMaybe<Scalars['Boolean']['input']>;
  gridOwner?: InputMaybe<Scalars['String']['input']>;
  notCustomer: Scalars['Boolean']['input'];
  ownerType?: InputMaybe<Array<InputMaybe<OwnerType>>>;
  production?: InputMaybe<Scalars['Boolean']['input']>;
};
